export default {
  LOGIN: "login",
  SIGNUP: "signup",
  CONNECT: "connect",
  LIBRARY: "library",
};
